import React, {useState} from 'react'

import UserDetails from './UserDetails';
import UserForm from './UserForm';

import {Provider} from 'react-redux';
import {createStore} from 'redux'
import rootReducer from './reducers/index'
const store=createStore(rootReducer)


function RApp2() {
    const [showDetails, setShowDetails] = useState(false);

  return (
    <div>
        <Provider store={store}>
            {!showDetails && <UserForm onSubmissionHandler={() => setShowDetails(true)} />}
            {showDetails && <UserDetails />}
        </Provider>
    </div>
  )
}

export default RApp2